// extracted by mini-css-extract-plugin
export var equalColumn = "_eq-0";